export enum SchoolYear {
  SY2026 = 2
}